module.exports = __webpack_public_path__ + "static/img/AgAABXq0GNc5WyvSHb1M3prxK3eSJlNN.ee3aaae.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/nbaip/sku/套装/AgAABXq0GNc5WyvSHb1M3prxK3eSJlNN.jpeg
// module id = GfAg
// module chunks = 0